module.exports = __webpack_public_path__ + "static/media/mike.02dee3fd.jpg";